/**
 * Debounce functions for better performance
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Function} fn The function to debounce
 */
let debounce = (fn) => {

	// Setup a timer
	let timeout;

	// Return a function to run debounced
	return () => {

		// Setup the arguments
		let context = this;
		let args = arguments;

		// If there's a timer, cancel it
		if (timeout) {
			window.cancelAnimationFrame(timeout);
		}

		// Setup the new requestAnimationFrame()
		timeout = window.requestAnimationFrame(() => {
			fn.apply(context, args);
		});
	}
};

(() => {

	let siteHeader = document.querySelector('.site-header');

	let isTop = () => {
		if (window.pageYOffset === 0) {
			siteHeader.classList.add('top');
		} else {
			siteHeader.classList.remove('top');
		}
	}

	let isTopDebounce = debounce(isTop);

	window.addEventListener('scroll', function (event) {
		isTopDebounce();
	}, false)

	window.addEventListener('load', function() {
		isTopDebounce();
	})

})();